import { Stack } from '@ltvco/refresh-lib/theme';
import { CommunityBuzz, MyGarageContainer } from '@ltvco/refresh-lib/v2';
import { useEffect } from 'react';

export function MyGarage() {
  useEffect(() => {
    document.title = 'My Vehicle - BeenVerified';
  }, []);

  return (
    <Stack justifyContent={'space-around'} sx={{ ml: 0, mt: 1, px: 1 }}>
      <MyGarageContainer
        communityBuzz={(vehicle) => (
          <CommunityBuzz
            make={vehicle.make || ''}
            model={vehicle.model || ''}
            year={vehicle.year?.toString() || ''}
            trim={vehicle.trim || 'Base'}
            limitIntroModalToSession={true}
          />
        )}
      />
    </Stack>
  );
}
